import {
    MuiPickersUtilsProvider,
    KeyboardTimePicker,
  } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { ru } from 'date-fns/locale'
import { parse, format, isValid } from 'date-fns';
import React, { useEffect, useMemo, useState } from "react"



export const TimeTable = ({
  values,
  setValues,
  ...params
}) => {

    class RuDateFnsUtils extends DateFnsUtils {
        constructor() {
          super({ locale: ru });
        }
      }

    const dateFormat = "HH:mm:ss";

    const parsedDate = useMemo(() => parse(params.value, dateFormat, new Date()), [params.value]);
    const [value, setValue] = useState(null);

    useEffect(() => {
        setValue(parsedDate)
    }, [parsedDate])

    const onChange = (newValue) => {
      let getRows = JSON.parse(JSON.stringify(values));
      const date = new Date(newValue);
    
      if (getRows.length !== 0 && isValid(date)) {
        let newRows = []
        getRows.map(row => {
          if (row.id === params.id) {
            let newRow = row;
            const formatDate = format(date, dateFormat);
            newRow[params.field] = formatDate;
            newRows.push(newRow);
          } else newRows.push(row)
        })
        
        setValues(newRows)
      }  
    }

    return(
        <MuiPickersUtilsProvider utils={RuDateFnsUtils}>
            <KeyboardTimePicker
              onBlur={() => onChange(value)}
              margin="normal"
              id="time-picker"
              ampm={false}
              value={value}
              onChange={(newValue) => setValue(newValue)}
              KeyboardButtonProps={{
                'aria-label': 'change time',
              }}
              onAccept={(newValue) => {
                // Срабатывает при выборе даты из календаря
                setValue(newValue);
                onChange(newValue)
            }}
        />
        </MuiPickersUtilsProvider>

    )
}